import { Box, Tab, Tabs } from '@mui/material';
import React, { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import AdminSectionHeader from '../AdminSectionHeader';
import TcowMassApproval from './TcowMassApproval';

type ApplicationTab = 'tcowMassApproval';

const ManageApplications: React.FC = () => {
  const { translatedText } = useContext(LocaleContext);
  const [activeTab, setActiveTab] = React.useState<ApplicationTab>('tcowMassApproval');

  return (
    <Box sx={{ width: '100%' }}>
      <AdminSectionHeader title={translatedText.admin.applicationsHeader} />
      <Tabs
        value={activeTab}
        onChange={(_, value: ApplicationTab) => setActiveTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
      >
        <Tab label={translatedText.admin.tabTcowMassApproval} value='tcowMassApproval' />
      </Tabs>
      <Box sx={{ p: 2 }}>{activeTab === 'tcowMassApproval' && <TcowMassApproval />}</Box>
    </Box>
  );
};

export default ManageApplications;
